import React, { lazy, Suspense } from 'react';

const LazySetting = lazy(() => import('./Setting'));

const SettingComponent = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; } | any) => (
  <Suspense fallback={null}>
    <LazySetting {...props} />
  </Suspense>
);

export default SettingComponent;
